export default "__VITE_ASSET__B2_OH0e___"